// @ts-nocheck
import * as config from './config';

import type { IEnvironment } from './interfaces';

export class Environment {
  private static instance: Environment;

  private environment: IEnvironment;

  private constructor(environmentName: EnvironmentNames) {
    this.environment = this.getEnvironmentProperties(environmentName);
  }

  public static getInstance(environmentName?: EnvironmentNames): Environment {
    if (!Environment.instance) {
      Environment.instance = new Environment(environmentName || process.env.REACT_APP_COBLI_ENV);
    }
    return Environment.instance;
  }

  private getEnvironmentProperties(environmentName: EnvironmentNames): IEnvironment {
    return config[environmentName];
  }

  public getEnvironment(): IEnvironment {
    return this.environment;
  }
}
